import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { MaintenanceView } from './MaintenanceView';

interface MaintenanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  maintenance: { active: boolean; content?: string; excerpt?: string } | null;
}

export const MaintenanceModal: React.FC<MaintenanceModalProps> = ({
  isOpen,
  onClose,
  maintenance
}) => {
  if (!maintenance?.active) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[500] bg-[#020617]"
        >
          <button
            onClick={onClose}
            className="absolute top-8 right-8 z-[60] w-12 h-12 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-white/40 hover:text-white hover:bg-white/10 transition-all shadow-2xl backdrop-blur-md"
          >
            <X size={20} />
          </button>

          <div className="h-full overflow-y-auto custom-scrollbar">
             <MaintenanceView content={maintenance.content} excerpt={maintenance.excerpt} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
